import { ACTIONS } from 'actions/student-course-upgrade-v2';
import RestReducer from './reducer';

export default RestReducer(ACTIONS, (state, { type, payload }) => {
  switch (type) {
    case ACTIONS.EMPTY_STORE_DATA:
      return payload;
    default:
      return state;
  }
});
